import e from"styled-components";const o=e.div`
	.time-picker__control {
		height: 40px;
		background-color: ${({theme:e})=>e.bg.primary};
		border-radius: 8px;
		box-sizing: border-box;
		border: none;
		width: 100%;

		&:focus {
			outline: none;
		}
	}

	.time-picker__single-value {
		color: ${({theme:e})=>e.text.input};
		font-size: 13.3333px;
	}

	svg {
		color: ${({theme:e})=>e.text.input};
	}
`;export{o as TimeContainer};
